import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { 
  GetProductQueryResponse, 
  GetProductsAlertQueryResponse, 
  GetProductsWarningQueryResponse, 
  GetProductsQueryResponse, 
  GetProductQueryByStoreResponse, 
  CreateProductCommand, 
  UpdateProductCommand 
} from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiSite.endsWith('/') 
      ? environment.apiSite.slice(0, -1) 
      : environment.apiSite;
  }

  // Get a single product by ID
  getProduct(params: { id: number }): Observable<GetProductQueryResponse> {
    return this.http.get<GetProductQueryResponse>(`${this.baseUrl}/api/Product/${params.id}`);
  }

  // Get a single product by ID
  getProductAlerts(): Observable<GetProductsAlertQueryResponse> {
    return this.http.get<GetProductsAlertQueryResponse>(`${this.baseUrl}/api/getProductsAlerts`);
  }

  // Get a single product by ID
  getProductsWarnings(): Observable<GetProductsWarningQueryResponse> {
    return this.http.get<GetProductsWarningQueryResponse>(`${this.baseUrl}/api/getProductsWarnings`);
  }

  // Get all products
  getAllProducts(): Observable<GetProductsQueryResponse> {
    return this.http.get<GetProductsQueryResponse>(`${this.baseUrl}/api/Product`);
  }

   // Get all products
   getProductByStore(params: { store: string }): Observable<GetProductQueryByStoreResponse> {
    //alert("in service: " + `${this.baseUrl}/api/Product/getProductByStore/${params.store}`);
    return this.http.get<GetProductQueryByStoreResponse>(`${this.baseUrl}/api/Product/getProductByStore/?store=${params.store}`);
  }

  // Create a new product
  createProduct(command: CreateProductCommand): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/Product`, command);
  }

  // Update an existing product
  updateProduct(command: UpdateProductCommand): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/api/Product`, command);
  }

  updateProducts(products: { id: number; title: string; stockCount: number }[]): Observable<any> {
    return this.http.put(`${this.baseUrl}/api/Product/UpdateBulk`, products);
  }

}